//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import { Feedback } from "@/utils/notify-toaster.js";

export default {
  name: "PhantomStock",
  components: {},
  data: function () {
    return {
      allCategories: false,
      allStores: false,
      allProducts: false,
      ghostStockConfigs: {},
      ghostStockSampleMonth: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      reasonCodes: null,
      loadingReasonCodes: false,
      model: 0,
    };
  },
  mounted: function () {
    BackendServices.getConfig("ghost_stock").then((response) => {
      this.ghostStockConfigs = response.data;
    });
    this.loadingReasonCodes = true;
    BackendServices.getReasonCodes().then((response) => {
      this.reasonCodes = response.data;
      this.loadingReasonCodes = false;
    });

  },
  methods: {
    saveGhostStockConfigs() {
      BackendServices.saveConfig("ghost_stock", this.ghostStockConfigs).then(
        (response) => {
          if (response.status === 200) {
            Feedback.success("Configurações guardadas com sucesso");
          } else {
            Feedback.error("Erro ao guardar configurações");
          }
        }
      );
    },

  },
  computed: {
    remaining() {
      return 100 - this.ghostStockConfigs.b_to_c_class_threshold;
    }
  },
};
